import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ArrowDropDown } from '@material-ui/icons';
import { StyleRulesCallback, WithStyles, withStyles } from '@material-ui/core';

import { OrganizationId } from 'yeself-common/typings/application/Application';

import { Organization } from 'Console/data/organizations/types';

const styles: StyleRulesCallback = (theme) => ({
    buttonTitle: {
        fontSize: theme.typography.pxToRem(12),
    },
    arrowIcon: {
        fontSize: theme.typography.pxToRem(21),
    },
    listItemText: {
        fontSize: theme.typography.pxToRem(14),
    },
});

interface AnalyticsButtonProps extends WithStyles<typeof styles> {
    onOrganizationItemClick: (organizationId: OrganizationId) => void;
    organizations: Organization[];
}

const AnalyticsButton = ({
    onOrganizationItemClick,
    organizations,
    classes,
}: AnalyticsButtonProps): React.ReactElement => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleAnalyticsButtonOnClick = useCallback((target: HTMLElement) => {
        setAnchorEl(target);
    }, []);

    const handleOnClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const handleOnOrganizationItemClick = useCallback(
        (organizationId: OrganizationId) => () => {
            onOrganizationItemClick(organizationId);
            setAnchorEl(null);
        },
        [onOrganizationItemClick]
    );

    if (organizations.length === 0) {
        return <></>;
    }

    if (organizations.length === 1) {
        return (
            <Button
                id="analytics-button"
                size="small"
                color="inherit"
                onClick={() => onOrganizationItemClick(organizations[0].id)}
            >
                <span className={classes.buttonTitle}>
                    <FormattedMessage id="Navigation.analytics" defaultMessage="Analytics" />
                </span>
            </Button>
        );
    }

    return (
        <>
            <Button
                id="analytics-button"
                size="small"
                color="inherit"
                aria-owns={anchorEl ? 'long-menu' : ''}
                aria-haspopup="true"
                onClick={(event) => handleAnalyticsButtonOnClick(event.currentTarget)}
            >
                <span className={classes.buttonTitle}>
                    <FormattedMessage id="Navigation.analytics" defaultMessage="Analytics" />
                </span>
                <ArrowDropDown className={classes.arrowIcon} />
            </Button>
            <Menu
                id="create-guide-menu"
                open={Boolean(anchorEl)}
                onClose={handleOnClose}
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {organizations.map((o) => (
                    <MenuItem
                        id="yeself-menu-item"
                        onClick={handleOnOrganizationItemClick(o.id)}
                        key={o.id}
                    >
                        <span className={classes.listItemText}>{o.name}</span>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default withStyles(styles)(AnalyticsButton);
